export const PANEL_TEXT = 'Your partner to co-create value through a design-led approach';
